import { createContext, useContext, useState } from "react";

interface ProviderProps {
  children: React.ReactNode | React.ReactNode[];
}

interface MouseEventContextType {
  mouseEventsArePaused: boolean;
  setMouseEventsArePaused: (newValue: boolean) => void;
}

const GlobalMouseEventContext = createContext<MouseEventContextType>(null!);

export const useGlobalMouseEventContext = () =>
  useContext(GlobalMouseEventContext);

export const GlobalMouseEventProvider: React.FC<ProviderProps> = ({
  children,
}) => {
  const [mouseEventsArePaused, setMouseEventsArePaused] = useState(false);

  return (
    <GlobalMouseEventContext.Provider
      value={{
        mouseEventsArePaused,
        setMouseEventsArePaused,
      }}
    >
      {children}
    </GlobalMouseEventContext.Provider>
  );
};
